<ion-input placeholder = "{{placeholder}}" class="form-input" type="text" #googlePlaces
[(ngModel)]="formatedAddress" (ionChange)="onManualAddressChange($event)" [ngClass]='{"placeholder-form" : class.form, "placeholder-broadcast": !class.form, "multi-patient": isMultiPatientAllowed}'>

</ion-input>